module.exports = __webpack_public_path__ + "img/H.1177a32f.jpg";